<aside class="sidebar" [class.open]="open">
  <div class="sidebar-header">
    <span class="logo-text">AXXYL</span>
    <span class="logo-sub">Admin</span>
  </div>

  <nav class="sidebar-nav">
    @for (item of visibleItems; track item.route) {
      <a
        class="nav-item"
        [routerLink]="item.route"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: isParentOfAnotherItem(item) }"
        (click)="closed.emit()"
      >
        <i [class]="item.icon"></i>
        <span>{{ item.label | translate }}</span>
      </a>
    }
  </nav>
</aside>
